interface IPasswordRule {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

interface IPasswordRuleResult extends IPasswordRule {
  met: boolean;
}

interface IPasswordValidationResult {
  rules: IPasswordRuleResult[];
  maxLengthError: string | null;
}

const MAX_PASSWORD_LENGTH = 64;

const PASSWORD_RULES: IPasswordRule[] = [
  {
    id: 'minLength',
    label: 'At least 12 characters',
    test: (password) => password.length >= 12,
  },
];

const validatePassword = (password: string): IPasswordValidationResult => {
  const rules = PASSWORD_RULES.map((rule) => ({
    ...rule,
    met: rule.test(password),
  }));

  const maxLengthError = password.length > MAX_PASSWORD_LENGTH ? 'Password must be 64 characters or fewer.' : null;

  return { rules, maxLengthError };
};

export default validatePassword;

export { MAX_PASSWORD_LENGTH, PASSWORD_RULES };
export type { IPasswordRule, IPasswordRuleResult, IPasswordValidationResult };
